import React from "react";
import { app_name } from "../../../config/config";
import useStyles from "./footer_styles";

export default function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.footer}>
      <p>
        &copy; {new Date().getFullYear()} {app_name}. All rights reserved.
      </p>
    </div>
  );
}
